// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentTypesTable_wrapper__Ccq+I","header":"DocumentTypesTable_header__KFXWX","title":"DocumentTypesTable_title__aY+W9","addButton":"DocumentTypesTable_addButton__7NME0"};